import Layout from '@/views/layout/Layout'
import Login from '@/views/login/index'
import Vue from 'vue'
import VueRouter from 'vue-router'
//客户预约
import CustomerTakeOrder from '@/views/take/CustomerTakeOrder'


const _import = require('./_import_' + process.env.NODE_ENV)

const routerPush=VueRouter.prototype.push;
VueRouter.prototype.push=function push(location){
    return routerPush.call(this,location).catch(error=>{})
}

Vue.use(VueRouter)

export const constantRouterMap = [
  {
      path: '/login',
      name: 'Login',
      component:Login,
      hidden: true,
      meta:{
          noLogin:true,
      }
  },
  {
      path: '/mobile',
      component: _import('mobile/MobileEntry'),
      hidden: true,
      meta:{
          noLogin:false,
      },
      children: [
          { path: 'stocktaking', component: _import('mobile/StockTakingMobile'), name: 'PDA库存盘点', meta: { noLogin: false } },
          { path: 'quickEntry', component: _import('mobile/QuickEntryMobile'), name: 'PDA采购入库', meta: { noLogin: false } }
      ]
  },
  {
      path: '/Card/Add',
      name: '客户提货',
      component: CustomerTakeOrder,
      // redirect: `${window.location.origin}/card/#/take`,
      beforeEnter: (to, from, next) => {
          window.location.href = `${window.location.origin}/card/index.html#/take`;
      },
      hidden: true,
      meta:{
          noLogin:true,
      }
  },
  {
      path: '/Card/Add/:Id',
      name: '客户扫描提货',
      component: CustomerTakeOrder,
      beforeEnter: (to, from, next) => {
          console.log(to, from, next);
          let Id = to.params.Id;
          window.location.href = `${window.location.origin}/card/index.html#/take/${Id}`;
      },
      hidden: true,
      meta:{
          noLogin:true,
      }
  },
  // {
  //     path: '/Card2/Add',
  //     name: '客户提货2',
  //     component: CardTakeOrderFirst,
  //     hidden: true,
  //     meta:{
  //         noLogin:true,
  //     }
  // },
  // {
  //     path: '/Card2/Add/:Id',
  //     name: '客户扫描提货2',
  //     component: CardTakeOrderFirst,
  //     hidden: true,
  //     meta:{
  //         noLogin:true,
  //     }
  // },
  {
      path: '/Card/Detail/:Id',
      name: '客户预约详情',
      component: _import('take/CustomerTakeDetail'),
      beforeEnter: (to, from, next) => {
          console.log(to, from, next);
          let Id = to.params.Id;
          window.location.href = `${window.location.origin}/card/index.html#/Card/Detail/${Id}`;
      },
      hidden: true,
      meta:{
          noLogin:true,
      }
  },
  {
      path: "/UploadTakeorder/:Id",
      component: _import('workflows/UploadTakeorder'),
      name: "发货单回传",
      hidden: true,
      meta:{
          noLogin:true,
      }
  },
  {
      path: "/ConfirmTakeOrder/:Id",
      component: _import('take/ConfirmTakeOrder'),
      name: "在线预约", //订单发货确认
      hidden: true,
      meta:{
          noLogin:true,
      }
  },
  {
      path: "/OrderTake/:Id",
      component: _import('take/OrderTake'),
      name: "在线无卡预约", //无卡预约
      hidden: true,
      meta:{
          noLogin:true,
      }
  },
  {
    path: "/info",
    component: _import('companyCustomer/SignInfo'),
    name: "信息", //用于签名审核页面
    hidden: true,
    meta:{
        noLogin:true,
    }
    },
    {
        path: "/expressDetail",
        component: _import('take/ExpressDetail'),
        name: "运单详情",
        hidden: true,
        meta:{
            noLogin:false,
        }
    },
    {
        path: "/wechat/groupConfig/:ConversationId",
        component: _import('wechat/groupConfig'),
        name: "群聊配置",
        hidden: true,
        meta:{
            noLogin:false,
        }
    },
    {
        path: '',
        component: Layout,
        redirect: '/dashboard',
        icon: 'icon-yibiaopan',
        // meta:{
        //     noLogin:true,
        // },
    //  name: '仪表板',
    //  hidden: true,
        noDropdown: true,
        children: [{ path: 'dashboard', component: _import('dashboard/Dashboard'), name: '仪表板' }]
    },

]

export default new VueRouter({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  {
      path: "/User",
      name: "用户",
      component: Layout,
      redirect: '/User/UserList',
      icon: 'icon-yonghu1',
      //meta: { role: ['admin', 'AddUser'] },
      children: [
          { path: "UserList", component: _import('user/UserList'), name: "用户列表", icon: 'icon-liebiao', meta: { role: ['UserView'] }, },
          { path: "AddUser", component: _import('user/AddUser'), name: "添加新用户", hidden: true, meta: { role: ['AddUser'] } },
          { path: "EditUser/:Id(\\d+)", component: _import('user/AddUser'), name: "编辑用户", hidden: true, meta: { role: ['EditUser'] } },
          { path: "RoleList", component: _import('user/RoleList'), name: "角色列表", icon: 'icon-jiaoseguanli', meta: { role: ['RoleView'] } },
          { path: "AddRole", component: _import('user/AddRole'), name: "添加新角色", hidden: true, meta: { role: ['AddRole'] } },
          { path: "EditRole/:Id(\\d+)", component: _import('user/AddRole'), name: "编辑角色", hidden: true, meta: { role: ['EditRole'] } },
          { path: "PermissionList", component: _import('user/PermissionList'), name: "权限列表", icon: 'icon-quanxian', meta: { role: ['PermissionView'] } },
          { path: "AddPermission", component: _import('user/AddPermission'), name: "添加新权限", hidden: true, meta: { role: ['AddPermission'] } },
          { path: "EditPermission/:Id(\\d+)", component: _import('user/AddPermission'), name: "编辑权限", hidden: true, meta: { role: ['EditPermission'] } },
          { path: "SetRolePermission/:Id(\\d+)", component: _import('user/SetRolePermission'), name: "设置角色权限", hidden: true, meta: { role: ['SetRolePermission'] } },
          { path: "UserInfo", component: _import('user/UserInfo'), name: "个人信息", hidden: true },
            { path: "LogList", component: _import('user/LogList'), name: "系统日志", icon: 'el-icon-tickets', meta: { role: ['LogList'] } },
            { path: "AccountInfo", component: _import('companyCustomer/AccountInfo'), name: "账户信息", icon: 'icon-liebiao', meta: { role: ['UserView'] }, },
      ]
  },
  {
      path: "/CompanyCustomer",
      name: "公司客户",
      component: Layout,
      redirect: '/CompanyCustomer/CompanyCustomerList',
      icon: 'icon-gongsi',
      //meta: { role: ['admin', 'AddUser'] },
      children: [
          { path: "CompanyCustomerList", component: _import('companyCustomer/CompanyCustomerList'), name: "公司客户列表", icon: 'icon-liebiao', meta: { role: ['CompanyCustomerList'] }, },
          { path: "AddCompanyCustomer", component: _import('companyCustomer/AddCompanyCustomer'), name: "添加公司客户", hidden: true,  meta: { role: ['AddCompanyCustomerList'] }, },
          { path: "EditCompanyCustomer/:Id(\\d+)", component: _import('companyCustomer/AddCompanyCustomer'), name: "编辑公司客户", hidden: true,  meta: { role: ['EditCompanyCustomerList'] }, },

      ]
  },
  {
      path: "/Product",
      name: "产品",
      component: Layout,
      redirect: '/Product/ProductList',
      icon: 'icon-chanpin',
      // meta: { role: ['admin', 'AddUser'] },
      children: [
          { path: "ProductList", component: _import('product/ProductList'), name: "产品列表", icon: 'icon-liebiao', meta: { role: ['ProductView'] } },
          { path: "AddProduct", component: _import('product/AddProduct'), name: "添加新产品", hidden: true, meta: { role: ['AddProduct'] } },
          { path: "EditProduct/:Id(\\d+)", component: _import('product/AddProduct'), name: "编辑产品", hidden: true, meta: { role: ['EditProduct'] } },
          { path: "CategoryList", component: _import('product/CategoryList'), name: "分类列表", icon: 'icon-fenlei', meta: { role: ['CategoryView'] } },
          { path: "AddCategory", component: _import('product/AddCategory'), name: "添加分类", hidden: true, meta: { role: ['AddCategory'] } },
          { path: "EditCategory/:Id(\\d+)", component: _import('product/AddCategory'), name: "编辑分类", hidden: true, meta: { role: ['EditCategory'] } },
          // { path: "TagList", component: _import('product/TagList'), name: "标签列表", icon: 'icon-common-xiangmubiaoqian-copy' },
          // { path: "AddTag", component: _import('product/AddTag'), name: "添加标签", hidden: true },
          // { path: "EditTag/:Id(\\d+)", component: _import('product/AddTag'), name: "编辑标签", hidden: true },
      ]
  },
  {
      path: "/Store",
      name: "门店&快递",
      component: Layout,
      redirect: '/Store/StoreList',
      icon: 'icon-weibiaoti--',
      // meta: { role: ['admin', 'AddUser'] },
      children: [
          { path: "StoreList", component: _import('store/StoreList'), name: "门店列表", icon: 'icon-liebiao', meta: { role: ['StoreView'] } },
          { path: "AddStore", component: _import('store/AddStore'), name: "添加门店", hidden: true, meta: { role: ['AddStore'] } },
          { path: "EditStore/:Id(\\d+)", component: _import('store/AddStore'), name: "编辑门店", hidden: true, meta: { role: ['EditStore'] } },
          { path: "ExpressList", component: _import('expresses/ExpressList'), name: "快递列表", icon: 'el-icon-document', meta: { role: ['ExpressList'] } },
          // { path: "AddExpress", component: _import('express/AddExpress'), name: "添加快递", hidden: true, meta: { role: ['AddExpress'] } },
          // { path: "EditExpress/:Id(\\d+)", component: _import('express/AddExpress'), name: "编辑快递", hidden: true, meta: { role: ['UpdateExpress'] } },
      ]
  },
  {
      path: "/Card",
      name: "卡券",
      component: Layout,
      redirect: '/Card/CardInfoList',
      icon: 'icon-qiaquan',
      // meta: { role: ['admin', 'AddUser'CardOperateList ] },
      children: [
          { path: "CardInfoList", component: _import('card/CardInfoList'), name: "卡券信息", icon: 'icon-qiaquan1', meta: { role: ['CardInfoView'] } },
          { path: "GenerateCard", component: _import('card/GenerateCard'), name: "生成卡券", hidden: true, meta: { role: ['GenerationCards'] } },
          { path: "EditGenerateCard/:Id(\\d+)", component: _import('card/GenerateCard'), name: "编辑卡券", hidden: true, meta: { role: ['EditCardInfo'] } },
          { path: "ViewGenerateCard/:Id(\\d+)", component: _import('card/ViewGenerateCard'), name: "查看卡券", hidden: true, meta: { role: ['CardsView'] } },
          { path: "PhysicalCardList", component: _import('card/PhysicalCardList'), name: "卡券产品", icon: 'icon-shitiqia', meta: { role: ['PhysicalCardView'] } },
          { path: "AddPhysicalCard", component: _import('card/AddPhysicalCard'), name: "卡券关联商品", hidden: true, meta: { role: ['AddPhysicalCard'] } },
          { path: "EditPhysicalCard/:Id(\\d+)", component: _import('card/AddPhysicalCard'), name: "编辑卡券产品", hidden: true, meta: { role: ['EditPhysicalCard'] } },
          { path: "CardDefineList", component: _import('card/CardDefineList'), name: "卡券定义", icon: 'icon-zidingyi', meta: { role: ['CardDefineView'] } },
          { path: "AddCardDefine", component: _import('card/AddCardDefine'), name: "添加卡券定义", hidden: true, meta: { role: ['AddCardDefine'] } },
          { path: "EditCardDefine/:Id(\\d+)", component: _import('card/AddCardDefine'), name: "编辑定义", hidden: true, meta: { role: ['EditCardDefine'] } },
          { path: "RedefineCard", component: _import('card/RedefineCard'), name: "重新定义卡券", hidden: true, meta: { role: ['RedefineCard'] } },
          { path: "ActivateCard", component: _import('card/ActivateCard'), name: "激活卡券", hidden: true, meta: { role: ['ActivateCard'] } },
          { path: "CancelActivateCard", component: _import('card/ActivateCard'), name: "取消激活卡券", hidden: true, meta: { role: ['CancelActivateCard'] } },
          { path: "CardOperateList", component: _import('card/CardOperateList'), name: "激活记录", icon: 'icon-shitiqia', meta: { role: ['CardOperateList'] } },
          { path: "ViewCardOperate/:Id(\\d+)", component: _import('card/ActivateCard'), name: "查看操作记录", hidden: true, meta: { role: ['ViewCardOperate'] } },
          { path: "AddCardToCompany", component: _import('card/CardToCompany'), name: "添加卡券公司", hidden: true, meta: { role: ['AddCardToCompany'] } },
          { path: "CardToCompanyList", component: _import('card/CardToCompanyList'), name: "卡券关联公司", icon: 'icon-shitiqia', meta: { role: ['CardToCompanyList'] } },
          { path: "EditCardToCompany/:Id(\\d+)", component: _import('card/CardToCompany'), name: "编辑卡券公司", hidden: true, meta: { role: ['EditCardToCompany'] } },
      ]
  },
  {
      path: "/Order",
      name: "订单",
      component: Layout,
      redirect: '/Order/OrderList',
      icon: 'icon-dingdan1',
      // meta: { role: ['admin', 'AddUser'] },
      children: [
          { path: "OrderList", component: _import('order/OrderList'), name: "订单列表", icon: 'icon-liebiao', meta: { role: ['OrderView'] } },
          { path: "AddOrder/:Id(\\d+)?", component: _import('order/AddOrder'), name: "创建订单", hidden: true, meta: { role: ['AddOrder'] } },
          //{ path: "AddOrder/:Id(\\d+)", component: _import('order/AddOrder'), name: "创建订单", hidden: true, meta: { role: ['AddOrder'] } },
          { path: "EditOrder/:Id(\\d+)", component: _import('order/AddOrder'), name: "编辑订单", hidden: true, meta: { role: ['EditOrder'] } },
          { path: "ScanOrder/:Id(\\d+)", component: _import('order/AddOrder'), name: "查看订单", hidden: true, meta: { role: ['ScanOrder'] } },
          { path: "OrderAddCards/:Id(\\d+)", component: _import('order/OrderAddCards'), name: "订单添加卡券", hidden: true, meta: { role: ['OrderAddCards'] } },
          { path: "OrderShip/:Id(\\d+)", component: _import('order/OrderShip'), name: "订单发货", hidden: true, meta: { role: ['AddTakeOrder'] } },
          { path: "ImportOrderShip/:Id(\\d+)", component: _import('order/ImportOrderShip'), name: "订单发货导入", hidden: true, meta: { role: ['AddTakeOrder'] } },
          { path: "ViewUnconfirmed/:Id(\\d+)", component: _import('order/ViewUnconfirmed'), name: "待确认发货", hidden: true, meta: { role: ['AddTakeOrder'] } },
          { path: "ImportUnconfirmed/:Id(\\d+)", component: _import('order/ImportUnconfirmed'), name: "待确认发货导入", hidden: true, meta: { role: ['AddTakeOrder'] } },
          { path: "EditOrderShip/:Id(\\d+)", component: _import('order/OrderShip'), name: "编辑发货", hidden: true, meta: { role: ['EditTakeOrder'] } },
          { path: "ScanOrderShip/:Id(\\d+)", component: _import('order/OrderShip'), name: "查看发货", hidden: true, meta: { role: ['EditTakeOrder'] } },
            // 订单退单
          { path: "AddReturnOrder/:orderId(\\d+)", component: _import('order/ReturnOrder'), name: "创建退货", hidden: true, meta: { role: ['AddReturnOrder'] } },
          { path: "ConfirmReturnOrder/:returnOrderId(\\d+)", component: _import('order/ReturnOrder'), name: "确认退货", hidden: true, meta: { role: ['AddReturnOrder'] } },
          { path: "ScanReturnOrder/:returnOrderId(\\d+)", component: _import('order/ReturnOrder'), name: "查看退货", hidden: true, meta: { role: ['AddReturnOrder'] } },

          // 客户退单
          { path: "ReturnOrder/:orderId(\\d+)", component: _import('order/ReturnOrder2'), name: "创建退单", hidden: true, meta: { role: ['AddReturnOrder'] } },

          // { path: "AddReturnOrder/:Id(\\d+)", component: _import('order/ReturnOrder2'), name: "创建退单", hidden: true, meta: { role: ['AddReturnOrder'] } },
          { path: "EditReturnOrder/:orderId(\\d+)", component: _import('order/ReturnOrder2'), name: "编辑退单", hidden: true, meta: { role: ['AddReturnOrder'] } },

          //{ path: "ReturnOrder/:Id(\\d+)", component: _import('order/ReturnOrder2'), name: "创建退单", hidden: true, meta: { role: ['AddReturnOrder'] } },
          { path: "CustomerList", component: _import('order/CustomerList'), name: "客户列表", icon: 'icon-kehu', meta: { role: ['CustomerView'] } },
          { path: "AddCustomer", component: _import('order/AddCustomer'), name: "添加客户", hidden: true, meta: { role: ['AddCustomer'] } },
          { path: "EditCustomer/:Id(\\d+)", component: _import('order/AddCustomer'), name: "编辑客户", hidden: true, meta: { role: ['EditCustomer'] } },
          { path: "CheckAccount", component: _import('order/CheckAccount'), name: "客户对账 ", hidden: true, meta: { role: ['CheckAccount'] } },
          { path: "CheckAccountPage", component: _import('order/CheckAccountPage'), name: "客户对账", icon: 'icon-liebiao', meta: { role: ['CheckAccount'] } },
          // { path: "ReOrderBillList", component: _import('order/ReOrderBillList'), name: "退单列表", icon: 'icon-liebiao', meta: { role: ['ReturnOrderList'] } },
          // { path: "AddReOrderBill", component: _import('order/AddReOrderBill'), name: "添加退单", hidden: true, meta: { role: ['AddReturnOrder'] } },
      ]
  },
  {
      path: "/TakeOrder",
      name: "发货",
      component: Layout,
      redirect: '/TakeOrder/TakeOrderList',
      icon: 'icon-yuyuedingdan',
      // meta: { role: ['admin', 'AddUser'] },
      children: [
          { path: "TakeOrderList", component: _import('take/TakeOrderList'), name: "发货列表", icon: 'icon-liebiao', meta: { role: ['TakeOrderView'] } },
          { path: "AddTakeOrder", component: _import('take/AddTakeOrder'), name: "客服发货", hidden: true, meta: { role: ['AddTakeOrder'] } },
          { path: "EditTakeOrder/:Id(\\d+)", component: _import('take/AddTakeOrder'), name: "编辑发货单", hidden: true, meta: { role: ['EditTakeOrder'] } },
          { path: "ScanTakeOrder/:Id(\\d+)", component: _import('take/AddTakeOrder'), name: "查看发货单", hidden: true, meta: { role: ['EditTakeOrder'] } },
          { path: "UploadExpress", component: _import('take/UploadExpress'), name: "上传快递", hidden: true, meta: { role: ['UploadExpress'] } },
          { path: "Separate/:Id(\\d+)", component: _import('take/Separate'), name: "拆分发货单", hidden: true, meta: { role: ['SeparateTakeOrder'] } },
          { path: "MergeTakeOrder", component: _import('take/MergeTakeOrder'), name: "合并发货单", icon: 'icon-merge', meta: { role: ['MergeTakeOrder'] } },
          { path: "TakeScan", component: _import('take/TakeScan'), name: "查看已发货", hidden: true, meta: { role: ['TakeOrderView'] } },
          { path: "DeliveryPrint", component: _import('take/DeliveryPrint'), name: "快递打印", icon: 'icon-merge', meta: { role: ['DeliveryPrint'] } },
          { path: "PreAssignTakeOrder", component: _import('take/PreAssignTakeOrder'), name: "预约分配供应商", icon: 'icon-liebiao', meta: { role: ['PreAssignTakeOrder'] } },
          { path: "BatchConfirmDelivery", component: _import('take/BatchConfirmDelivery'), name: "待确认发货", icon: 'icon-merge', meta: { role: ['EditTakeOrder'] } },
          //{ path: "ResetTakeOrderDelivery", component: _import('take/ResetTakeOrderDelivery'), name: "重新指派发货", icon: 'icon-liebiao', meta: { role: ['TakeOrderView'] } },
      ]
  },
  {
      path: "/Vendor",
      name: "供应商",
      component: Layout,
      redirect: '/vendor/VendorList',
      icon: 'icon-supplier',
      // meta: { role: ['admin', 'AddUser'] },
      children: [
          { path: "VendorList", component: _import('vendor/VendorList'), name: "供应商列表", icon: 'icon-liebiao', meta: { role: ['VendorView'] } },
          { path: "AddVendor", component: _import('vendor/AddVendor'), name: "添加供应商", hidden: true, meta: { role: ['AddVendor'] } },
          { path: "EditVendor/:Id(\\d+)", component: _import('vendor/AddVendor'), name: "编辑供应商", hidden: true, meta: { role: ['EditVendor'] } },
          { path: "VendorCheckAccountPage", component: _import('vendor/VendorCheckAccountPage'), name: "供应商对账", icon: 'icon-liebiao', meta: { role: ['VendorCheckAccount'] } },
      ]
  },

  {
      path: "/Stock",
      name: "采购",
      component: Layout,
      redirect: '/Stock/StockList',
      icon: 'icon-caigoudingdan',
      children: [
          { path: "StockList", component: _import('stock/StockList'), name: "采购列表", icon: 'icon-liebiao', meta: { role: ['StockApplyView'] } },
          { path: "AddStock", component: _import('stock/AddStock'), name: "添加采购", hidden: true, meta: { role: ['AddStockApply'] } },
          { path: "EditStock/:Id(\\d+)", component: _import('stock/AddStock'), name: "编辑采购", hidden: true, meta: { role: ['EditStockApply'] } },
          { path: "ScanStock/:Id(\\d+)", component: _import('stock/AddStock'), name: "查看采购", hidden: true, meta: { role: ['ScanStock'] } },
          { path: "PutInStock", component: _import('stock/PutInStock'), name: "采购入库", icon: 'icon-shangpinruku', meta: { role: ['PutInStock'] } },
          { path: "PutRecordList", component: _import('stock/PutRecordList'), name: "入库记录", icon: 'icon-churukujilu', meta: { role: ['PutRecordList'] } },
          { path: "QuickEntryComplete/:Id(\\d+)", component: _import('stock/QuickEntryComplete'), name: "补充采购信息", hidden: true, meta: { role: ['EditStockApply'] } }
      ]
  },

  {
      path: "/Inventory",
      name: "库存",
      component: Layout,
      redirect: '/Inventory/InventoryWarning',
      icon: 'icon-navicon-kcpdd',
      children: [
          { path: "InventoryWarning", component: _import('inventory/InventoryWarning'), name: "库存预警", icon: 'el-icon-warning-outline', meta: { role: ['InventoryForecastView'] } },
          { path: "InventoryThreshold", component: _import('inventory/InventoryThreshold'), name: "阈值配置", icon: 'el-icon-setting', meta: { role: ['InventoryWarningThreshold'] } },
          { path: "StockProduct", component: _import('stock/StockProduct'), name: "库存查看", icon: 'icon-liebiao', meta: { role: ['StockProduct'] } },
          { path: "StockProductRecord", component: _import('stock/StockProductRecord'), name: "产品进销存记录", hidden: true, icon: 'icon-liebiao', meta: { role: ['StockProductRecord'] } },
          { path: "Packing", component: _import('stock/Packing'), name: "组拆包作业", icon: 'icon-liebiao', meta: { role: ['Packing'] } },
          { path: "StockTakingList", component: _import('stock/StockTakingList'), name: "库存盘点", icon: 'el-icon-document-checked', meta: { role: ['StockProduct'] } },
          { path: "CreateStockTaking", component: _import('stock/StockTakingCreate'), name: "创建盘点单", hidden: true, meta: { role: ['StockProduct'] } },
          { path: "EditStockTaking/:id(\\d+)", component: _import('stock/StockTakingPC'), name: "编辑盘点单", hidden: true, meta: { role: ['StockProduct'] } },
          { path: "ViewStockTaking/:id(\\d+)", component: _import('stock/StockTakingPC'), name: "查看盘点单", hidden: true, meta: { role: ['StockProduct'] } }
      ]
  },

  {
      path: "/Move",
      name: "调拨",
      component: Layout,
      redirect: '/Move/MoveList',
      icon: 'icon-stockallocation',
      // meta: { role: ['admin', 'AddUser'] },
      children: [
          { path: "MoveList", component: _import('move/MoveList'), name: "调拨列表", icon: 'icon-liebiao', meta: { role: ['MoveList'] } },
          { path: "AddMove", component: _import('move/AddMove'), name: "添加调拨", hidden: true, meta: { role: ['AddMove'] } },
          { path: "EditMove/:Id(\\d+)", component: _import('move/AddMove'), name: "编辑调拨", hidden: true, meta: { role: ['EditMove'] } },
          { path: "ScanMove/:Id(\\d+)", component: _import('move/AddMove'), name: "查看调拨", hidden: true, meta: { role: ['ScanMove'] } },
      ]
  },

  // {
  // path: "/Agent",
  // name: "经销商",
  // component: Layout,
  // redirect: '/Agent/AgentList',
  // icon: 'icon-weibiaoti--',
  // // meta: { role: ['admin', 'AddUser'] },
  // children: [
  // 	{ path: "AgentList", component: _import('agent/AgentList'), name: "经销商列表", icon: 'icon-liebiao', meta: { role: ['AgentView'] } },
  // 	{ path: "AddAgent", component: _import('agent/AddAgent'), name: "添加经销商", hidden: true, meta: { role: ['AddAgent'] } },
  // 	{ path: "EditAgent/:Id(\\d+)", component: _import('agent/AddAgent'), name: "编辑经销商", hidden: true, meta: { role: ['EditAgent'] } },
  // ]
  // },

  {
      path: "/Summary",
      name: "汇总",
      component: Layout,
      redirect: '/Summary/CardSumyList',
      icon: 'icon-fenleihuizong',
      children: [
          { path: "CardSumyList", component: _import('summary/CardSumyList'), name: "卡券汇总", icon: 'icon-qiaquan2', meta: { role: ['CardSumyList'] } },
          { path: "OrderSummary", component: _import('summary/OrderSummary'), name: "销售统计", icon: 'icon-liebiao', meta: { role: ['ViewOrderSummary'] } },
      ]
  },

  //系统设置
  {
      path: "/Setting",
      name: "系统设置",
      component: Layout,
      redirect: '/Setting/CommonRule',
      icon: 'icon-jifenguize',
      children: [
          { path: "CommonRule", component: _import('takerule/CommonRule'), name: "预约规则", icon: 'icon-guize', meta: { role: ['CommonRule'] } },
          { path: "TemplateList", component: _import('shortMessage/TemplateList'), name: "配置参数", icon: 'el-icon-tickets', meta: { role: ['GetSettings'] } },
          { path: "AddTemplate", component: _import('shortMessage/AddTemplate'), name: "添加参数", hidden: true, meta: { role: ['AddSetting'] } },
          { path: "UpdateTemplate/:Id(\\d+)", component: _import('shortMessage/AddTemplate'), name: "编辑参数", hidden: true, meta: { role: ['UpdateSetting'] } },
        //   { path: "Workflow", component: _import('workflows/WorkflowList'), name: "工作流", icon: 'el-icon-set-up', meta: { role: ['CommonRule'] } },
          { path: "TaskList", component: _import('tasks/taskList'), name: "计划任务", icon: 'el-icon-set-up', meta: { role: [] } },
          { path: "ExecutionList", component: _import('tasks/executionList'), name: "计划任务记录", icon: 'el-icon-set-up', meta: { role: [] } },
          { path: "AddTask", component: _import('tasks/addTask'), name: "添加计划任务",hidden: true, meta: { role: [] } },
          { path: "UpdateTask/:Id(\\d+)", component: _import('tasks/addTask'), name: "编辑计划任务",hidden: true, meta: { role: [] } },
          { path: "BotList", component: _import('bots/wechatBindingList'), name: "机器人", icon: 'el-icon-chat-dot-round', meta: { role: [] } },
          

      ]
  },

  //发送短信管理
  {
      path: "/Message",
      name: "短信管理",
      component: Layout,
      redirect: '/Message/NoteList',
      icon: 'el-icon-message',
      children: [
          { path: "NoteList", component: _import('shortMessage/NoteList'), name: "短信列表", icon: 'el-icon-document', meta: { role: ['GetMessageRecord'] } },
          { path: "SettlementList", component: _import('shortMessage/SettlementList'), name: "结算记录", icon: 'el-icon-news',  meta: { role: ['GetMsgSettlementList'] } },
      ]
  },

  //快递管理
  {
    path: "/Express",
    name: "快递管理",
    component: Layout,
    redirect: '/Express/ExpressList',
    icon: 'icon-kuaidi',
    children: [
      // { path: "ExpressList", component: _import('express/ExpressList'), name: "快递列表", icon: 'el-icon-document', meta: { role: ['ExpressList'] } },
      { path: "AddExpress", component: _import('expresses/AddExpress'), name: "添加快递", hidden: true, meta: { role: ['AddExpress'] } },
      { path: "EditExpress/:Id(\\d+)", component: _import('expresses/AddExpress'), name: "编辑快递", hidden: true, meta: { role: ['AddExpress'] } },
    ]
  },

  {
      path: "/Print",
      name: "打印",
      hidden: true,
      component: _import('layout/layoutEmpty'),
      children: [
          { path: "PrintOrder/:orderId(\\d+)", component: _import('order/PrintOrder'), name: "订单打印", hidden: true },
          { path: "PrintTakeOrder/:orderId(\\d+)", component: _import('take/PrintTakeOrder'), name: "预约打印", hidden: true },
      ]
  },
    {
        path: "/Invoice",
        name: "开票管理",
        component: Layout,
        redirect: '/Invoice/IProductList',
        icon: 'icon-chanpin',
        // meta: { role: ['admin', 'AddUser'] },
        children: [
            { path: "IProductList", component: _import('invoice/IProductList'), name: "开票产品", icon: 'icon-liebiao', meta: { role: ['InvoiceProductView'] } },
            { path: "AddIProduct", component: _import('invoice/AddIProduct'), name: "添加开票产品", hidden: true, meta: { role: ['AddIProduct'] } },
            { path: "EditIProduct/:Id(\\d+)", component: _import('invoice/AddIProduct'), name: "编辑开票产品", hidden: true, meta: { role: ['EditIProduct'] } },
            // { path: "ICategoryList", component: _import('invoice/ICategoryList'), name: "产品分类", icon: 'icon-fenlei', meta: { role: ['InvoiceCategoryView'] } },
            // { path: "AddICategory", component: _import('invoice/AddICategory'), name: "添加开票产品分类", hidden: true, meta: { role: ['AddInvoiceCategory'] } },
            // { path: "EditICategory/:Id(\\d+)", component: _import('invoice/AddICategory'), name: "编辑开票产品分类", hidden: true, meta: { role: ['EditInvoiceCategory'] } },
            { path: "InvoiceList", component: _import('invoice/InvoiceList'), name: "销售发票", icon: 'icon-fenlei', meta: { role: ['InvoiceListView'] } },
            { path: "InvoicePurList", component: _import('invoice/InvoicePurList'), name: "采购发票", icon: 'icon-fenlei', meta: { role: ['InvoiceListView'] } },
            { path: "InvoiceStatistics", component: _import('invoice/InvoiceStatistics'), name: "发票统计", icon: 'icon-liebiao', meta: { role: ['InvoiceStatisticsView'] } },
            { path: "AddInvoice", component: _import('invoice/AddInvoice'), name: "添加开票", hidden: true, meta: { role: ['AddInvoice'] } },
            { path: "EditInvoice/:Id(\\d+)", component: _import('invoice/AddInvoice'), name: "编辑开票", hidden: true, meta: { role: ['EditInvoice'] } },
            { path: "IdentifyInvoice", component: _import('invoice/IdentifyInvoice'), name: "识别发票", hidden: true, meta: { role: ['InvoiceListView'] } },
            { path: "MaterialLockList", component: _import('invoice/MaterialLockList'), name: "库存锁定", icon: 'icon-fenlei', meta: { role: ['MaterialLockView'] } },
            { path: "AddMaterialLock", component: _import('invoice/AddMaterialLock'), name: "添加库存锁定", hidden: true, meta: { role: ['AddMaterialLock'] } },
            { path: "EditMaterialLock/:Id(\\d+)", component: _import('invoice/AddMaterialLock'), name: "编辑库存锁定", hidden: true, meta: { role: ['EditMaterialLock'] } },
            { path: "InvoiceCompanyList", component: _import('invoice/InvoiceCompanyList'), name: "开票抬头", icon: 'icon-fenlei', meta: { role: ['InvoiceCompanyView'] } },
            { path: "AddInvoiceCompany", component: _import('invoice/AddInvoiceCompany'), name: "添加开票抬头", hidden: true, meta: { role: ['AddInvoiceCompany'] } },
            { path: "EditInvoiceCompany/:Id(\\d+)", component: _import('invoice/AddInvoiceCompany'), name: "编辑开票抬头", hidden: true, meta: { role: ['EditInvoiceCompany'] } },
            { path: "InvoiceTagList", component: _import('invoice/InvoiceTagList'), name: "发票标签", icon: 'icon-common-xiangmubiaoqian-copy', meta: { role: ['InvoiceTagView'] } },
            { path: "AddInvoiceTag", component: _import('invoice/AddInvoiceTag'), name: "添加发票标签", hidden: true, meta: { role: ['AddInvoiceTag'] } },
            { path: "EditInvoiceTag/:Id(\\d+)", component: _import('invoice/AddInvoiceTag'), name: "编辑发票标签", hidden: true, meta: { role: ['EditInvoiceTag'] } },
        ]
    },
]
